import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    Select
} from '@chakra-ui/react';
import {
    FormikErrors, FormikHandlers
} from 'formik';
import React from 'react';

import { isDefined } from '@utils';

type FormInputProps = {
    'data-testid': string
    errors: FormikErrors<any>
    isRequired: boolean
    labelText: string
    name: string
    onChangeHandler: FormikHandlers['handleChange']
    options: Array<string>
    value: string
    isReadOnly?: boolean
};

export const FormSelect = ({
    'data-testid': dataTestId,
    errors,
    isRequired,
    labelText,
    name,
    onChangeHandler,
    options,
    value,
    isReadOnly = false
}: FormInputProps) => {
    return (
        <FormControl
            isRequired={isRequired}
            isInvalid={isDefined(errors[name])}
        >
            <FormLabel
                id={`label-${name}`}
                htmlFor={name}
            >
                {labelText}
            </FormLabel>
            <Select
                data-testid={dataTestId}
                focusBorderColor={'primary.500'}
                name={name}
                onChange={onChangeHandler}
                value={value}
                id={name}
                isReadOnly={isReadOnly}
            >
                {options.map((option) => (
                    <option
                        key={option}
                        value={option}
                        id={option}
                    >
                        {option}
                    </option>
                ))}
            </Select>
            <FormErrorMessage data-testid={`error-${dataTestId}`}>
                {errors[name] && errors[name]}
            </FormErrorMessage>
        </FormControl>
    );
};
